module.exports = __webpack_public_path__ + "img/Blink.a95f7a00.png";